import styled from 'styled-components/macro'
import DefaultModal, {
  Content as ModalContent,
  Title as ModalTitle,
  SubTitle as ModalSubTitle,
  Buttons as ModalButtons,
} from 'components/ModalV2/Modal'
import DefaultInput from 'components/Inputs/Input/Input'

export const Container = styled(DefaultModal)`
  ${ModalContent} {
    padding: 40px;
    max-width: 586px;
    width: 586px;
  }
`

export const Title = styled(ModalTitle)``

export const SubTitle = styled(ModalSubTitle)``

export const Buttons = styled(ModalButtons)``

export const FormContainer = styled.div`
  margin-top: 16px;
`

export const Input = styled(DefaultInput)``
